import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(r.data);
        navigate("/", { replace: true, state: { user: r.data } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center" data-testid="auth-callback">
      <div className="w-8 h-8 rounded-full border-2 border-terracotta border-t-transparent animate-spin" />
    </div>
  );
}
